import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

const PermissionGuard = ({ required, requiredAny, adminOnly, children }) => {
    const { permissions, role } = useOutletContext();

    // Admin always has access
    if (role === 'admin') return children;

    // If adminOnly is true, block non-admins
    if (adminOnly) {
        alert("관리자만 접근 가능합니다.");
        return <Navigate to="/dashboard" replace />;
    }

    // Whitelist: permissions must exist and key must be true
    if (!permissions) return null; // Loading or no permissions -> Block

    // Check specific permission — requiredAny는 나열한 키 중 하나만 있어도 통과한다
    // (단일 required 사용처는 [required] 한 벌이 되어 동작이 바뀌지 않는다)
    const allowedKeys = requiredAny || [required];
    if (!allowedKeys.some((key) => key && permissions[key])) {
        alert("접근 권한이 없습니다.");
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PermissionGuard;
